<div class="user-dashboard p-4">
  <div class="row">
    <div class="col-12">
      <h2>Welcome to your Dashboard</h2>
      <p>This is the user panel. Here you can manage your settings, view activity, and explore features.</p>
    </div>
  </div>
</div>
